import CREATE_ALL_ITINERARY_DAYS from './CreateAllItineraryDays.graphql'
import CREATE_ITINERARY_DAY from './CreateItineraryDay.graphql'

import GET_CONTENT_EVENT from './GetContentEvent.graphql'
import GET_CONTENT_POI from './GetContentPOI.graphql'
import GET_CUSTOMIZED_PLAN from './GetCustomizedPlan.graphql'

import UPDATE_CUSTOMIZED_PLAN_END_DATE from './UpdateCustomizedPlanEndDate.graphql'
import UPDATE_EVENT_TITLE from './UpdateEventTitle.graphql'
import UPDATE_CONTENT_EVENT_START_DATE from './UpdateContentEventStartDate.graphql'
import UPDATE_CONTENT_EVENT_DATES from './UpdateContentEventDates.graphql'
import UPDATE_ITINERARY_DAY_TITLE from './UpdateItineraryDayTitle.graphql'
import UPDATE_ITINERARY_DAY_FAVORITE from './UpdateItineraryDayFavorite.graphql'
import UPDATE_ITINERARY_DAY_ORDER from './UpdateItineraryDayOrder.graphql'
import UPDATE_ITINERARY_DAY_DATE from './UpdateItineraryDayDate.graphql'
import UPDATE_ITINERARY_DAY_INDEX from './UpdateItineraryDayIndex.graphql'

import LINK_ITINERARY_DAY_AND_CONTENT_EVENT from './LinkItineraryDayAndContentEvent.graphql'
import UN_LINK_ITINERARY_DAY_AND_CONTENT_EVENT from './UnLinkItineraryDayAndContentEvent.graphql'
import LINK_ITINERARY_DAY_AND_TRIP_DETAILS from './LinkItineraryDayAndTripDetails.graphql'

import UN_LINK_ITINERARY_DAY_AND_TRIP_DETAILS from './UnLinkItineraryDayAndContentEvent.graphql'
import LINK_ITINERARY_DAY_AND_NOTE from '../Note/LinkItineraryDayAndNote.graphql'
import UN_LINK_ITINERARY_DAY_AND_NOTE from '../Note/UnLinkItineraryDayAndNote.graphql'

export default {
  CREATE_ALL_ITINERARY_DAYS,
  CREATE_ITINERARY_DAY,
  GET_CONTENT_EVENT,
  GET_CONTENT_POI,
  GET_CUSTOMIZED_PLAN,
  UPDATE_CUSTOMIZED_PLAN_END_DATE,
  UPDATE_EVENT_TITLE,
  UPDATE_CONTENT_EVENT_START_DATE,
  UPDATE_CONTENT_EVENT_DATES,
  UPDATE_ITINERARY_DAY_TITLE,
  UPDATE_ITINERARY_DAY_FAVORITE,
  UPDATE_ITINERARY_DAY_ORDER,
  UPDATE_ITINERARY_DAY_DATE,
  UPDATE_ITINERARY_DAY_INDEX,
  LINK_ITINERARY_DAY_AND_CONTENT_EVENT,
  UN_LINK_ITINERARY_DAY_AND_CONTENT_EVENT,
  LINK_ITINERARY_DAY_AND_TRIP_DETAILS,
  UN_LINK_ITINERARY_DAY_AND_TRIP_DETAILS,
  LINK_ITINERARY_DAY_AND_NOTE,
  UN_LINK_ITINERARY_DAY_AND_NOTE
}



// WEBPACK FOOTER //
// src/graphql/TripPlanner/index.js